import {
    Button,
    Card,
    CardContent,
    CardHeader,
    FormControl,
    FormHelperText,
    Grid,
    Paper,
    TextField
} from '@mui/material';
import InfoIcon from 'mdi-material-ui/InformationOutline';
import { useEffect, useState } from 'react';
import { Controller, useForm } from 'react-hook-form';
import toast from 'react-hot-toast';
import CustomTooltip from 'src/components/CustomTooltip';
import { apiService } from '../../api/axiosClient';

const SectionMail = ({ site }) => {
    const [mailConfig, setMailConfig] = useState({});

    useEffect(() => {
        setMailConfig({
            host: site?.email_host,
            port: site?.email_port,
            protocol: site?.email_protocol }
        )
    }, [site])

    const {
        control: controlEmail,
        handleSubmit: handleSubmitEmail,
        formState: { errors: errorsEmail }
    } = useForm()

    const onSubmitEmail = async (data) => {
        const params = {
            "to": data.test_email,
            "subject": "THIS IS TEST EMAIL",
            "text": "this is sent from java mail service"
        };

        try {
            await apiService.post('/sendTemplate', params);
            toast.success('메일이 전송되었습니다.')
        } catch (error) {
            toast.error('메일 전송이 실패했습니다.')
        }
    }

    return (
        site &&
        <Card>
            <Paper component="div" sx={{ display: 'flex', alignItems: 'center' }} >
                <CardHeader title='메일 정보' titleTypographyProps={{ variant: 'h6' }} />
                <CustomTooltip title={
                    <>
                    메일서버가 정상적으로 동작 중인지 확인할 수 있습니다.<br/>
                    아래 입력칸에 테스트 메일을 발송하실 메일 주소를 입력하시면,<br/>
                    [메일검사] 라는 제목으로 테스트 메일을 발송합니다
                    </>
                }>
                    <InfoIcon color='primary'/>
                </CustomTooltip>
            </Paper>

            <CardContent>
                <Grid container spacing={6}>

                    <Grid item xs={12} sm={5}>
                        <TextField fullWidth
                            label="SMTP 전자 메일 서버"
                            value={mailConfig.host || ''}
                            InputProps={{
                                readOnly: true,
                            }}
                            variant="standard"
                        />
                    </Grid>
                    <Grid item xs={12} sm={3}>
                        <TextField
                            label="메일 포트"
                            value={mailConfig.port || ''}
                            InputProps={{
                                readOnly: true,
                            }}
                            variant="standard"
                        />
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <TextField
                            label="암호화 프로토콜"
                            value={mailConfig.protocol || ''}
                            InputProps={{
                                readOnly: true,
                            }}
                            variant="standard"
                        />
                    </Grid>

                </Grid>

                <form key={2} onSubmit={handleSubmitEmail(onSubmitEmail)} id="mallform">
                    <Grid container spacing={6} direction="column" sx={{ mt: 1 }}>
                        <Grid item xs={12}>
                            <FormControl fullWidth>
                                <Controller
                                    name='test_email'
                                    control={controlEmail}
                                    rules={{ required: true }}
                                    render={({ field: { value, onChange } }) => (
                                        <TextField
                                            type='email'
                                            value={value || ''}
                                            label='전자 메일 주소'
                                            id='test_email'
                                            onChange={onChange}
                                            placeholder='전자 메일 주소를 입력해주세요'
                                            error={Boolean(errorsEmail.test_email)}
                                            aria-describedby='validation-async-test_email'
                                            variant="standard"
                                        />
                                    )}
                                />
                                {errorsEmail.test_email && (
                                    <FormHelperText sx={{ color: 'error.main' }} id='validation-async-test_email'>
                                        수신 메일 주소를 입력해주세요
                                    </FormHelperText>
                                )}
                            </FormControl>
                        </Grid>

                        <Grid item xs={12} sx={{ pt: theme => `${theme.spacing(4)} !important` }}>
                            <Button type="submit" form="mallform" variant='contained'> 보내기 </Button>
                        </Grid>
                    </Grid>
                </form>

            </CardContent>
        </Card>
    )
}

export default SectionMail
